import React from 'react'

const ChatmailBeta = ({ text = 'βeta' }) => {

  return (
    <div style={{ backgroundColor: '#DD3077', height: '20px', borderRadius: '10px', paddingLeft: '8px', paddingRight: '8px', display: 'flex', alignItems: 'center', justifyContent: 'center', minWidth: '46px', marginLeft: '10px' }}>
      <span style={{ color: '#FFFFFF', fontSize: '12px', fontWeight: '600', margin: '0' }}>{text}</span>
    </div>
  )

}

export default ChatmailBeta
